import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { RootState } from "@/store";
import { setShowTemplateModal } from "@/store/slice/uiSlice";
import { Template } from "@/types/template";

import TemplateFooter from "./TemplateFooter";
import TemplateOverviewModal from "./TemplateOverviewModal";
import { TemplateSelectionModal } from "./TemplateSelectionModal";

export function TemplateModal() {
  const dispatch = useDispatch();

  const [selectedTemplate, setSelectedTemplate] = useState<Template | null>(
    null
  );

  const showTemplateModal = useSelector(
    (state: RootState) => state.ui.showTemplateModal
  );

  const handleOpenChange = (open: boolean) => {
    dispatch(setShowTemplateModal(open));
    setSelectedTemplate(null);
  };

  const handleTemplateSelect = useCallback((template: Template) => {
    setSelectedTemplate(template);
  }, []);

  return (
    <Dialog open={showTemplateModal} onOpenChange={handleOpenChange}>
      <DialogContent className="w-[calc(100vw-2rem)] max-w-[1200px] max-h-[calc(100dvh-2rem)] grid-rows-[auto_minmax(0,1fr)_auto] rounded-lg p-0 gap-0">
        <DialogHeader className="space-y-0 summary-header px-4 py-4 pr-12">
          <DialogTitle className="text-xl text-txtHeading">
            {selectedTemplate
              ? selectedTemplate.title
              : "Get started with spatial analysis"}
          </DialogTitle>
          <DialogDescription className="text-xs text-txtHeading leading-5">
            {!selectedTemplate &&
              "Choose a template or start with a blank canvas"}
          </DialogDescription>
        </DialogHeader>

        {selectedTemplate ? (
          <TemplateOverviewModal selectedTemplate={selectedTemplate} />
        ) : (
          <TemplateSelectionModal onSelect={handleTemplateSelect} />
        )}

        <div className="flex items-center justify-between border-t border-neutral-200 px-6 py-4">
          <TemplateFooter
            selectedTemplate={selectedTemplate}
            setSelectedTemplate={setSelectedTemplate}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
